import { makeAutoObservable, runInAction } from "mobx";

export default class criteriaValueStore {
  criteriaValue = [];

  constructor() {
    makeAutoObservable(this);
  }

  setData = (data) => {
    this.criteriaValue = [];
    runInAction(() => {
      this.criteriaValue = data;
    });
  };

  deleteCriteriaValue = (id) => {
    let newState = this.criteriaValue.filter((criteriaValue) => criteriaValue.id !== id);
    this.criteriaValue = [];
    this.criteriaValue = newState;
  };
}